import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { DataCoreModule } from "./core/data/data-core.module";
import { UtilModule } from "./core/util/util.module";
import { SharedModule } from "./shared/shared.module";
import { ConfigService } from './config.service';
import { ConfigLoader } from './config-loader';
import { MyApp } from './app.component';

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    UtilModule,
    DataCoreModule,
    SharedModule
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps: [ConfigService],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler
    },
  ],
  entryComponents: [
    MyApp,
  ],
  bootstrap: [IonicApp]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts